<template>
  <v-layout
    row
    fill-height
    wrap
    style="height:100%"
  >
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout
      class="table__container--panel"
      wrap
    >
      <v-spacer />
      <v-flex
        xs5
        class="table__wrapper--center table__wrapper--filter"
      >
        <v-layout
          align-right
          justify-end
        >
          <v-text-field
            type="text"
            v-model="filter"
            placeholder="Treść filtra"
            clearable
            :hint="numberFiltered + '/' + numberAll"
            persistent-hint
            filled
          >
          </v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>
    <ag-grid-vue
      style="width: 100%; min-height: 200px;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </v-layout>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import ExportTableData from "../../../shared/ExportTableData";

export default {
  name: "App",
  props: {
    featureId: Number,
    objectTable: String
  },
  data: vm => ({
    currentChange: [],
    filter: "",
    numberAll: "",
    numberFiltered: "",
    rowData: [],
    tableTitle: "SingleObjectHistoryTable"
  }),
  components: {
    AgGridVue,
    ExportTableData
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    gridOptions() {
      let gridOptions = {
        rowData: this.loadData(),
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onFilterModified: this.filteredNumber,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onFilterChanged: this.filterColumn,
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          lessThan: "Mniejsza niż",
          greaterThan: "Większa niż",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        },
        getNodeChildDetails: function (parent) {
          if(parent.attributes) {
            return {
              group: true,
              children: parent.attributes,
              expanded: true
            };
          } else {
            return null;
          }
        }
      };
      return gridOptions;
    }
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "ID",
        field: "id"
      },
      {
        headerName: "Warstwa",
        field: "layer_name"
      },
      {
        headerName: "Operacja",
        field: "operation"
      },
      {
        headerName: "Data zmiany",
        field: "time"
      },
      {
        headerName: "Użytkownik",
        field: "username"
      }
    ];
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    },
    assignId(data) {
      this.oid = data;
      this.loadData();
    },
    filteredNumber() {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    loadData() {
      if(!this.oid) return;
      let payload = {
        table: this.objectTable,
        oid: 1,
        verbose: true
      };
      this.$store.dispatch("getSingleHistory", payload).then(r => {
        console.log(r)
        if(r) {
          this.gridOptions.api.setRowData(r.data);
          this.numberAll = r.data.length;
          this.numberFiltered = this.numberAll;
        }
      });
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    }
  },
  mounted() {
    this.$root.$on("sendId", this.assignId);
    this.numberAll = this.currentChange.length;
    this.numberFiltered = this.numberAll;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/history/SingleObjectHistoryTable.vue